<template>
  <div>
    <MainForm
      :name="FORM_NAMES.offerDigital"
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPageDigital"
      :ui-form="uiForm"
    >
      <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.appointmentDigital"
    ui-title=""
    ui-subtitle=""
    ui-error-message="Please review the fields marked in red"
    ui-button-text="Submit"
  >
 
   <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetAppointmentDigital" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:10px">Next Step</p>
  <p style="font-weight: 500;font-size: 15px">{{this.isAppointmentText}}</p>
  </FieldsetModel> -->
  <FieldsetModel :ui="uiBaseFieldset" name="fieldSetAppointmentDigital2" >
      <p style=" color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:10px">Congratulations</p>
  <p style="font-weight: 500;font-size: 15px">{{this.isApprovedLimit}}</p>
  </FieldsetModel>
  
    <FieldsetModel :ui="uiBaseFieldset" :name="name" ui-columns="2" ui-title="Where would you like your card delivered?">
          <UiWrapper
            :name="FIELD_NAMES.addressLine1Home"
            label="Address Line 1"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.addressLine2Home"
            label="Address Line 2"
            :validations="addressValidations"
          >
            <InputText data-forced-fullwidth="true" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.residentialEmirate" label="Emirate" optional>
            <Dropdown placeholder="Emirate" :options="EMIRATE_LIST_CARD" />
          </UiWrapper>
          <UiWrapper :name="FIELD_NAMES.homeCountryCountry" label="Country" optional>
            <Suggest
              :exact-match="true"
              placeholder="Country"
              :get-formatted-item="formatMatchedString"
              :get-suggestions="getCountriesAppointment"
            />
          </UiWrapper>
          <UiWrapper
            :name="FIELD_NAMES.homeCountryPoscode"
            label="PO Box"
            optional
            :validations="pinCodeValidations"
          >
            <InputText />
          </UiWrapper>
    </FieldsetModel>

  </StepModel>
    </MainForm>
  </div>
</template>

<script>
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import FIELDSET_NAMES from "@/forms/constants/fieldset-names";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";
// // Shared Comps

// Ui Components
import {
  InputText,
  InputSlide,
  Dropdown,
  PlainText,
  Choice,
  Feedback,
  InputTime,
  Suggest,
} from "@dunia/ui";

// Utils
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Constants
import FIELD_NAMES from "@/forms/constants/field-names";
import { isFutureDateCondition, withinMonthRange } from "@/forms/conditions";
import sharedComponentMixin from "@/forms/components/shared/shared-component-mixin";
import * as conditions from "@/forms/conditions";
import { patternCondition } from "@/forms/conditions";
import {
  APPOINTMENT_PLACE_OPTIONS,
  AT_MY_OFFICE,
  NOMINEE_RELATIONSHIP_OPTIONS,
  MOBILE_STARTING_NUMBER,
  MOBILE_NUMBER_LENGTH,
  MOBILE_NUMBER_LENGTH_GLOBAL,
  DIGIT_CHARS,
  NAMES_CHARS,
  MAPPED_PHONE_CODE,
  ADDRESS_CHARS,
} from "@/forms/constants/onboarding-logic";
import { USE } from "@/forms/constants/nbc-logic";
import store from "@/store";
import { SET_OFFER_REJECTED } from "@/lib/constants/mutations";
import FieldsetMobilePhone from "@/forms/components/shared/fieldsets/mobile-phone";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
export default {
  name: "OnboardDunia",

  mixins: [FormComponentMixin, sharedComponentMixin],

  components: {
    // Components
    InputSlide,
    PlainText,

    MainForm,
    StepModel,
    InputText,
    Dropdown,
    Suggest,
    FieldsetModel,
    UiWrapper,
    Choice,
    FieldsetMobilePhone,
    FieldsetFullName,
   
  },
  props: {
    name: {
      type: String,
      default: FIELDSET_NAMES.appointmentSetDate,
    },
    titleOfffice: {
      type: String,
      default: "Please enter your Office address below",
    },
    titleHome: {
      type: String,
      default: "Please enter your UAE residential address below",
    },
    timeOptions: {
      type: Array,
      default: () => [
        {
          value: "7am - 9am",
          label: "7am - 9am",
        },
        {
          value: "9am - 11am",
          label: "9am - 11am",
        },
        {
          value: "11am - 1pm",
          label: "11am - 1pm",
        },
        {
          value: "1pm - 3pm",
          label: "1pm - 3pm",
        },
        {
          value: "3pm - 5pm",
          label: "3pm - 5pm",
        },
        {
          value: "5pm - 7pm",
          label: "5pm - 7pm",
        },
      ],
    },
    validations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits",
        },
        {
          errorMessage: "Your phone must start with a 5",
          condition: conditions.patternCondition(MOBILE_STARTING_NUMBER),
          name: "check-is-mobile-starting-number",
        },
        {
          errorMessage: "Your phone must have 9 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH),
          name: "check-is-mobile-length",
        },
      ],
    },
    validationsGlobal: {
      type: Array,
      default: () => [
        {
          errorMessage: "Invalid character",
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: "check-is-mobile-only-digits",
        },

        {
          errorMessage: "Your phone must be between 9-11 digits",
          condition: conditions.patternCondition(MOBILE_NUMBER_LENGTH_GLOBAL),
          name: "check-is-mobile-length",
        },
      ],
    },
    addressValidations: {
      type: Array,
      default: () => [
        {
          errorMessage:
            "Field contains invalid characters. Albhabets, Numbers and special character (- , / space) are allowed.",
          condition: patternCondition(ADDRESS_CHARS),
          name: "address-chars",
        },
      ],
    },
    pinCodeValidations: {
      type: Array,
      default: () => [
        {
          errorMessage: "Field contains invalid characters.",
          condition: patternCondition(DIGIT_CHARS),
          name: "pincode-chars",
        },
      ],
    },
    prefix: {
      type: String,
      default: "+971",
    },
    maxlength: {
      type: Number,
      default: 9,
    },
    minlength: {
      type: Number,
      default: 9,
    },
    minlengthGlobal: {
      type: Number,
      default: 11,
    },
  },
  data: () => ({
    USE_LOAN_OPTIONS: USE,
    APPOINTMENT_PLACE_OPTIONS,
    NOMINEE_RELATIONSHIP_OPTIONS,
  }),
   mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {
    isAppointmentPlaceSelected() {
      return !!this.fieldValues(FIELD_NAMES.appointmentPlace);
    },

    isAppointmentAtOffice() {
      return this.fieldValues(FIELD_NAMES.appointmentPlace) === AT_MY_OFFICE;
    },

    showAppointmentAddress() {
      return !this.isCompanyListed || this.isAppointmentPlaceSelected;
    },
    creditCardType() {
      var cardType = this.$store.state.productTypeFromCreditScoreCalculation;
      return `Deem ${cardType}!`;
    },
    getAppianCardType() {
      return this.$store.state.appianCardType;
    },
    getDoubleSecureText() {
      return (
        "" + this.$store.state.appianCardType + "".toUpperCase() ===
          "PLATINUM" ||
        "" + this.$store.state.appianCardType + "".toUpperCase() === "TITANIUM"
      );
    },
    isHomeAddress() {
      if (this.$store.state.addressCount) {
        //document.getElementsByName('addressLine1')[0].value="";
        //document.getElementsByName('addressLine2')[0].value="";
      }
      return this.$store.state.addressCount ? true : false;
    },
    isOfficeAddress() {
      return !this.$store.state.addressCount ? true : false;
    },
    isEligibleBt() {
      var fixedIncome = this.$store.state.incomeFixed;
      var bureauScore = this.$store.state.bureauScore;
     
      if (parseInt("" + fixedIncome + "") < 5000) {
        return false;
      } else if (
        parseInt("" + fixedIncome + "") >= 5000 &&
        parseInt("" + bureauScore + "") >= 600
      ) {
        return true;
      } else {
        return false;
      }
    },
   
    //  isHome(){
    //   return this.fieldValues(FIELD_NAMES.homeAddress)==='HOME';
    // }
    // isIncomeInfoButtonClicked() {
    //   if (this.$store.state.incomeInfoNext) {
    //     return this.$store.state.incomeInfoNext;
    //   }
    // }
  },

  updated() {
   
  },
  methods: {
    rejectOffer() {
      store.commit(SET_OFFER_REJECTED, { offerRejected: "OfferRejected" });
      this.goToForm("Credit Card Offer Rejected");
    },

    finishCallback() {
      //if (!this.$store.state.offerRejected) {
      var employeeCodes = this.$store.state.employeeCodes;
      var subtitleMessage = "";
      var titleMessage = "";

      if (this.$store.state.employeeCodes) {
        titleMessage = `Conditionally Approved!`;
        subtitleMessage = `Congratulations you qualify for a Deem Credit Card. Your application for a Deem Credit Card qualifies for up to AED ${this.getAppianPrescreened}. 
          Your customer identification number is ${this.getCifNumber} (${this.getRiskFlag}).`;
      } else {
        titleMessage = `Congratulations  ${this.userName}!`;
        subtitleMessage = `You are approved for a Deem Credit Card. Our team will be in touch with you shortly. We have shared a link with you to upload your documents.`;
      }
      this.showEndPage({
        title: "",
        subtitle: "",
        //actionNameEndForm: "Thanks"
      });
    },
    //}
  },
  // watch: {
  //   isIncomeInfoButtonClicked(value) {
  //     var timeControl = document.getElementsByName("appointmentTime")[0];
  //     if (value === "clicked") {
  //       if (timeControl) {
  //         console.log("timer control found.");
  //         timeControl.pickatime({
  //           // 12 or 24 hour
  //           twelvehour: true
  //         });
  //       }
  //     }
  //   }
  // }
};
// var timepicker = new TimePicker('time', {
//   lang: 'en',
//   theme: 'blue-grey'
// });
// timepicker.on('change', function(evt) {

//   var value = (evt.hour || '00') + ':' + (evt.minute || '00');
//   evt.element.value = value;

// });
</script>
